import { KeyValuePipe } from '@angular/common'
import { Component, Input } from '@angular/core'
import { FeatureWithIndex } from '@core/models/geojson-edition.model'
import { EditableArrayOrObjectComponent } from './editable-array-or-object/editable-array-or-object.component'
@Component({
  selector: 'app-editable-popup-geojson',
  imports: [KeyValuePipe, EditableArrayOrObjectComponent],
  templateUrl: './editable-popup-geojson.component.html',
})
export class EditablePopupGeojsonComponent {
  @Input() features: FeatureWithIndex[] = []
  @Input() isEditable: boolean = false
}
